<mat-card>
  <app-card-header
    [title]="title"
    icono="report"
    [botonCerrar]="true"
    (cerrar)="this.dialog.closeAll()"
  ></app-card-header>
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <mat-card-content class="card-content-crear">
        <!-- Tipo del Evento -->
        <section class="inputs-group">
          <ng-select
            [items]="listadoCategorias"
            bindLabel="nombre"
            bindValue="_id"
            formControlName="idListadoCategoria"
            placeholder="Tipo de Evento"
            [notFoundText]="'No hay tipo de eventos creados'"
            style="width: 100%"
            multiple="false"
            searchable="true"
            appendTo="body"
            [addTag]="addTag.bind(this)"
            [loading]="creandoNuevoTag"
          ></ng-select>
        </section>
        <!-- Codigos -->
        <section class="inputs-group">
          <ng-select
            [items]="codigosEvento"
            bindLabel="codigo"
            bindValue="codigo"
            formControlName="codigoReportado"
            placeholder="Códigos"
            [notFoundText]="'No hay Códigos'"
            style="width: 100%"
            multiple="false"
            [searchFn]="searchCodigo"
            searchable="true"
            appendTo="body"
            (change)="setCodigo($event)"
            required
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.codigo }} - {{ item.descripcion }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.codigo }} - {{ item.descripcion }}
            </ng-template>
          </ng-select>
        </section>
        @if (mostrarZona) {
          <section class="inputs-group" [formGroup]="configZona">
            <!-- Parti -->
            <mat-form-field style="flex: 1">
              <mat-label>Partición</mat-label>
              <input
                matInput
                formControlName="particion"
                type="number"
                required
              />
            </mat-form-field>
            <!-- Zona -->
            <mat-form-field style="flex: 1">
              <mat-label>Zona</mat-label>
              <input matInput formControlName="zona" type="number" required />
            </mat-form-field>
          </section>
        }

        <!-- Categoria -->
        <section class="inputs-group">
          <ng-select
            [items]="categoriasEvento"
            bindLabel="nombre"
            bindValue="_id"
            formControlName="idCategoriaEvento"
            placeholder="Categoría"
            [notFoundText]="'No hay categorías creadas'"
            style="width: 100%"
            multiple="false"
            searchable="true"
            (change)="setCategoria($event)"
            appendTo="body"
            required
          ></ng-select>
        </section>

        <!-- Mas opciones -->
        <div class="row-center">
          <div style="margin: 1em">
            <mat-label>Notificación Push</mat-label>
            <mat-checkbox
              color="primary"
              formControlName="notificar"
            ></mat-checkbox>
          </div>
          <div style="margin: 1em">
            <mat-label>Requiere Atención</mat-label>
            <mat-checkbox
              color="primary"
              formControlName="atender"
            ></mat-checkbox>
          </div>
          <div style="margin: 1em">
            <mat-label>No Derivar</mat-label>
            <mat-checkbox
              color="primary"
              formControlName="noDerivar"
            ></mat-checkbox>
          </div>
        </div>
        @if (form?.value?.notificar) {
          <div>
            <p>Notificar a los usuarios</p>
            <!-- USUARIOS -->
            <ng-select
              [items]="usuarios"
              placeholder="Usuarios"
              loadingText="Cargando..."
              typeToSearchText="Buscar..."
              notFoundText="No se encontraron resultados"
              formControlName="idsUsuarios"
              [multiple]="true"
              [closeOnSelect]="false"
              [bindValue]="'_id'"
              [appendTo]="'body'"
              [searchFn]="searchUsuario"
              required
            >
              <ng-template ng-label-tmp let-item="item">
                <span>{{ item.usuario }}</span>
              </ng-template>

              <ng-template
                ng-option-tmp
                let-item="item"
                let-item$="item$"
                let-index="index"
              >
                <div style="padding-bottom: 5px">
                  <span>{{ item.usuario }}</span>
                  <span style="font-size: 0.7em">
                    ({{ item.datosPersonales?.telefono }})
                  </span>
                </div>
              </ng-template>
            </ng-select>
          </div>
        }
        @if (form?.value?.atender && idCliente) {
          <div>
            <!-- Clientes -->
            <app-cliente-selector
              formControlName="idsClientesQuePuedenAtender"
              [idClienteFinal]="idCliente"
              [multiple]="true"
            ></app-cliente-selector>
          </div>

          <!-- Horarios de atención -->
          @if (form?.value?.atender && idCliente) {
            <div>
              <app-config-horarios-atencion
                formControlName="configHorariosAtencion"
                [idClienteFinal]="idCliente"
              ></app-config-horarios-atencion>
            </div>
          }
        }
      </mat-card-content>
      <!-- Botones -->
      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="this.dialog.closeAll()"
          text="Cancelar"
          icon="close"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          [disabled]="!this.form.valid || this.loading"
          color="primary"
          text="Guardar"
          icon="save"
          type="submit"
        ></app-button>
      </mat-card-actions>
    </form>
  }
</mat-card>
